import { createLoading } from "../../../../../utils/loading";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import { validateError } from "../../../../../utils/validate";
import { useForm as createUseForm } from "@ant-design-vue/use";
import { initUseForm } from "../../../../../utils/form";
import { addModal } from "../../../../../app.logic";
import lodash from "lodash";
import { modalStyleForm } from "../../../../../utils/constant";
import i18n from "../../../../../i18n";

export const { isLoading, setIsLoading } = createLoading();

export const ConfirmActionForm = defineAsyncComponent(() => import("./ConfirmActionForm"));

export const openModalForm = ({ props, onOk, bind }) => {
    const refs = reactive({ form: null });
    const options = addModal({
        bind: lodash.merge(
            lodash.cloneDeep(modalStyleForm),
            {
                okButtonProps: { disabled: false },
                title: i18n.global.t("views.request.freeSale.modal.titleConfirm"),
                width: "500px",
                onOk: () => {
                    refs.form.callOnClickModalOk().then(record => {
                        onOk?.(record);
                        options.bind.onCancel();
                    });
                }
            },
            bind
        ),
        render: () => (
            <ConfirmActionForm
                ref={e => {
                    if (e) refs.form = e;
                }}
                {...props}
            ></ConfirmActionForm>
        )
    });
    return options;
};

export const createForm = () => {
    return {};
};

export const createRules = () => {
    return {};
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef) }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const createField = () => {
    return [];
};

export const loadForm = ({ props, data }) => {
    setIsLoading(true);
    const { form } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise.then(page => initUseForm({ data, page })).finally(() => setIsLoading(false));
};

export const initForm = ({ props, data, refs }) => {
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    loadForm({ props, data, refs });
};